import request from '@/utils/request'

/**
 * 首页商品列表（热门推荐也是这个）
 * https://www.showdoc.com.cn/1003739271891029/10377132360933545
 */
export function fetchGoods(data) {
    return request({
        url: '/api/selection_library/goods/list',
        data,
        method: 'post'
    })
}

/**
 * 商品详情
 * https://www.showdoc.com.cn/1003739271891029/10385846184305758
 */
export function fetchGoodsDetail(data) {
    return request({
        url: '/api/selection_library/goods/detail',
        data,
        method: 'post'
    })
}

/**
 * 商品规格
 */
export function fetchSpec(data) {
    return request({
        url: '/api/selection_library/detail_spec',
        data,
        method: 'post'
    })
}

export function fetchSku(data) {
    return request({
        url: '/api/selection_library/detail_sku_one',
        data,
        method: 'post'
    })
}


export function fetchGoodsLink(data) {
    return request({
        url: '/api/selection_library/copy_detail_url',
        data,
        method: 'post'
    })
}

/**
 * 商品分享
 * https://www.showdoc.com.cn/1003739271891029/10418482290240045
 */
export function fetchGoodsShare(data) {
    return request({
        url: '/api/selection_library/goods/share',
        data,
        method: 'post'
    })
}

/**
 * 猜你喜欢商品
 * https://www.showdoc.com.cn/1003739271891029/10387670049405836
 */
export function fetchGoodsLike(data) {
    return request({
        url: '/api/selection_library/like_goods/list',
        data,
        method: 'post'
    })
}

/**
 * 收藏分类
 * https://www.showdoc.com.cn/1003739271891029/10418486110999884
 */
export function fetchCollectionCate() {
    return request({
        url: '/api/selection_library/goods/like/cate',
        method: 'get'
    })
}

/**
 * 收藏分类
 * https://www.showdoc.com.cn/1003739271891029/10418487766991141
 */
export function editCollectionCate(data,) {
    return request({
        url: '/api/selection_library/goods/like/add_cate',
        method: 'post',
        data
    })
}


/**
 * 收藏商品
 * https://www.showdoc.com.cn/1003739271891029/10418491139119054
 */
export function addCollection(data, pvd = 'tikTok') {
    let url = '/api/selection_library/goods/add_like'
    if (pvd === 'kuaishou') {
        url = '/api/selection_library/kuaishou_goods/add_like'
    }
    return request({
        url,
        data,
        method: 'post'
    })
}

/**
 * 收藏商品列表
 * https://www.showdoc.com.cn/1003739271891029/10418491139119054
 */
export function fetchCollections(data, pvd = 'tikTok') {
    let url = '/api/selection_library/goods/like/list'
    if (pvd === 'kuaishou') {
        url = '/api/selection_library/kuaishou_goods/like/list'
    }
    return request({
        url,
        data,
        method: 'post'
    })
}

/**
 * 取消收藏商品
 * https://www.showdoc.com.cn/1003739271891029/10418503857907878
 */
export function deleteCollection(data, pvd = 'tikTok') {
    let url = '/api/selection_library/goods/cancel_like'
    if (pvd === 'kuaishou') {
        url = 'api/selection_library/kuaishou_goods/cancel_like'
    }
    return request({
        url,
        data,
        method: 'post'
    })
}


/**
 * 添加商品橱窗
 * tik_tok 抖音,kuaishou 快手
 * https://www.showdoc.com.cn/1003739271891029/10418559759210260
 */
export function addWindow(data, pvd = 'tikTok') {
    let url = '/api/selection_library/user/tik_tok/add_product'
    if (pvd === 'kuaishou') {
        url = '/api/selection_library/user/kuaishou/add_product'
    }
    return request({
        url,
        data,
        method: 'post'
    })
}


/**
 * 橱窗列表
 * https://www.showdoc.com.cn/1003739271891029/10418561197354079
 */
export function fetchWindow(data, pvd = 'tikTok') {
    let url = '/api/selection_library/goods/windows/list'
    if (pvd === 'kuaishou') {
        url = '/api/selection_library/kuaishou_goods/windows/list'
    }
    return request({
        url,
        data,
        method: 'post'
    })
}
